module.exports = __webpack_public_path__ + "img/badge-list-thumb-139.c89d076f.png";